import HttpService from "./HttpService";
import { api } from "../common/enviroment";

export default class UserService {
  httpService = new HttpService();

  getAll = (maxResultCount, skipCount, search) => {
    return this.httpService.get(`/services/app${api.USER_SERVICE}/GetAll?${maxResultCount ? "MaxResultCount="+maxResultCount+"&" : ""}${skipCount ? "SkipCount="+skipCount+"&" : ""}${search ? "Keyword="+search+"&" : ""}`);
  };

  create = (data) => {
    return this.httpService.post(`/services/app${api.USER_SERVICE}/Create`, data);
  }

  delete = (id) => {
    return this.httpService.delete(`/services/app${api.USER_SERVICE}/Delete?Id=${id}`);
  }

  deleteAll = (datas) => {
    const reqs = datas.map(data=>this.delete(data.id))
    const reqsWithError = reqs.map((req, i) => req.then(res => ({...res, userName: datas[i].userName})).catch(error => ({...error, userName: datas[i].userName})) )
    return this.httpService.all(reqsWithError)
  }

  update = (data) => {
    return this.httpService.put(`/services/app${api.USER_SERVICE}/Update`, data);
  }

  resetPassword = (data) => {
    return this.httpService.post(`/services/app${api.USER_SERVICE}/ResetPassword`, data);
  }

  getPermissions = () =>{
    return this.httpService.get(`/services/app${api.USER_SERVICE}/GetPermissionsByUser`);
  }

}